import { RootStateCarteira } from '../../store/carteiraReducer';
import * as S from './styles';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { PageBanner } from 'base/src/components/PageBanner';
import { useEffect } from 'react';
import { GetPagamentos } from '../../store/pagamento/actions/pagamentoAction';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'base/src/components/Tabs';

import PagamentosTodos from './tabs/Pagamentos/index'
import PagamentosPendencias from './tabs/PagamentosPendencias';
import PagamentosCancelados from './tabs/PagamentosCancelados';

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    Pagamentos: state.PagamentoReducer.Pagamento,
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
  }),
  { GetPagamentos }
);

export interface HistoricoPagamentoComponentProps extends PropsFromRedux<typeof connector> { }

function HistoricoPagamento({ GetPagamentos, CarteiraUsuario } : HistoricoPagamentoComponentProps) {
  useEffect(() => {
    if (CarteiraUsuario.length > 0) {
      GetPagamentos({ From: '', To: '' }, CarteiraUsuario[0].CarteiraID, () => { });
    }
  }, [GetPagamentos, CarteiraUsuario]);

  return (
    <S.Container>
      <PageBanner title="Seus pagamentos" subtile="Acompanhe o histórico de seus pagamentos" />
      <Tabs defaultValue="tab1">
        <TabsList>
          <TabsTrigger value='tab1'>Pagamentos</TabsTrigger>
          <TabsTrigger value='tab2'>Pendentes</TabsTrigger>
          <TabsTrigger value='tab3'>Cancelados</TabsTrigger>
        </TabsList>
        <TabsContent value='tab1'>
          <PagamentosTodos />
        </TabsContent>
        <TabsContent value='tab2'>
          <PagamentosPendencias />
        </TabsContent>
        <TabsContent value='tab3'>
          <PagamentosCancelados />
        </TabsContent>
      </Tabs>
    </S.Container>
  );
}

export default connector(HistoricoPagamento);
